<div class="back-panel">
  <a [routerLink]="backLink"
     role="link"
     class="back-panel__back">
    <span><i class="back-panel__icon" aria-hidden="true"></i>{{ backLabel }}</span>
  </a>
</div>
